"use strict";
'use client';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames2 = _interopRequireDefault(require("classnames"));
var _debounce = _interopRequireDefault(require("lodash/debounce"));
var _react = _interopRequireWildcard(require("react"));
var _visuallyHiddenModule = _interopRequireDefault(require("../../../style/display/visually-hidden.module.scss"));
var _imageUrlModifier = require("../../../utils/imageUrlModifier/imageUrlModifier");
var _getProductUrl = _interopRequireDefault(require("../../../utils/product/getProductUrl"));
var _swatchesModule = _interopRequireDefault(require("./swatches.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Swatches = function Swatches(_ref) {
  var swatches = _ref.swatches,
    title = _ref.title,
    id = _ref.id,
    baseUrl = _ref.baseUrl,
    handleClick = _ref.handleClick,
    handleMoreSwatchesClick = _ref.handleMoreSwatchesClick,
    hasLimitedSwatches = _ref.hasLimitedSwatches,
    _ref$imageLoading = _ref.imageLoading,
    imageLoading = _ref$imageLoading === void 0 ? 'lazy' : _ref$imageLoading,
    className = _ref.className,
    selectedSwatch = _ref.selectedSwatch,
    hasSwatchTextButNoRoundels = _ref.hasSwatchTextButNoRoundels,
    showNotDisplayedTotal = _ref.showNotDisplayedTotal,
    forceResize = _ref.forceResize;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    showMoreAvailable = _useState2[0],
    setShowMoreAvailable = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = _slicedToArray(_useState3, 2),
    notDisplayedTotal = _useState4[0],
    setNotDisplayedTotal = _useState4[1];
  var _useState5 = (0, _react.useState)(10),
    _useState6 = _slicedToArray(_useState5, 2),
    maxSwatchesToDisplay = _useState6[0],
    setMaxSwatchesToDisplay = _useState6[1];
  var swatchListRef = (0, _react.useRef)(null);
  var swatchItemRef = (0, _react.useRef)(null);
  var getMaxSwatchesToDisplay = function getMaxSwatchesToDisplay(swatchListWidth) {
    if (Math.round(swatchListWidth) <= 120) {
      return 3;
    }
    if (Math.round(swatchListWidth) <= 175) {
      return 5;
    }
    if (Math.round(swatchListWidth) <= 260) {
      return 6;
    }
    return 10;
  };
  var checkShowMoreAvailable = (0, _react.useCallback)(function () {
    if (!swatches || !swatchListRef.current || !swatchItemRef.current) {
      return;
    }
    var swatchListWidth = swatchListRef.current.clientWidth;
    var swatchItemWidth = swatchItemRef.current.clientWidth;
    if (showNotDisplayedTotal) {
      var maxSwatches = getMaxSwatchesToDisplay(swatchListWidth);
      var totalRemaining = swatches.length - maxSwatches;
      setMaxSwatchesToDisplay(maxSwatches);
      setNotDisplayedTotal(totalRemaining);
    } else {
      var _maxSwatches = swatchListWidth / swatchItemWidth;
      setShowMoreAvailable(swatches.length > _maxSwatches);
    }
  }, [swatches, forceResize]);
  (0, _react.useEffect)(function () {
    if (!swatches || swatches.length <= 1) {
      return;
    }
    checkShowMoreAvailable();
    var handleResize = (0, _debounce.default)(checkShowMoreAvailable, 150);
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, [checkShowMoreAvailable, swatches]);
  if (!swatches || swatches.length <= 1) {
    return null;
  }
  if (hasSwatchTextButNoRoundels) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _classnames2.default)(_swatchesModule.default.swatches, _swatchesModule.default.swatchesCount, className),
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        "data-testid": "swatches-number-of-colours",
        children: [swatches.length, " colours"]
      })
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: (0, _classnames2.default)(_swatchesModule.default.swatches, [className, _defineProperty({}, _swatchesModule.default['swatches--limitedSwatches'], hasLimitedSwatches)]),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: _visuallyHiddenModule.default.visuallyHidden,
      children: "View this product in other colours by selecting one of the following:"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("ul", {
      ref: function ref(swatchList) {
        return swatchListRef.current = swatchList;
      },
      className: _swatchesModule.default.swatchesList,
      children: [(showNotDisplayedTotal ? swatches.slice(0, 10) : swatches).map(function (swatch, i) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
          ref: function ref(swatchItem) {
            swatchItemRef.current = swatchItem;
          },
          className: (0, _classnames2.default)(_swatchesModule.default.swatchItem, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _swatchesModule.default['swatchItem--unavailable'], !swatch.isAvailable), _swatchesModule.default['swatchItem--selected'], (selectedSwatch === null || selectedSwatch === void 0 ? void 0 : selectedSwatch.color) === swatch.color || !(selectedSwatch !== null && selectedSwatch !== void 0 && selectedSwatch.color) && i === 0), _swatchesModule.default.swatchItem__withTotal, showNotDisplayedTotal), _swatchesModule.default.swatchItem__withTotal__hidden, showNotDisplayedTotal && i + 1 > maxSwatchesToDisplay)),
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
            className: _swatchesModule.default.swatchItem__button,
            "data-testid": "swatch-button",
            onClick: function onClick(event) {
              return handleClick(event, i);
            },
            tabIndex: "0",
            title: "".concat(swatch.color).concat(swatch.isAvailable ? '' : ' - Out of stock'),
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
              alt: "".concat(swatch.color, " ").concat(swatch.isAvailable ? '' : ' - Out of stock'),
              className: _swatchesModule.default.swatchItem__image,
              loading: imageLoading,
              src: (0, _imageUrlModifier.modifyImageUrlQueryParams)(swatch.colorSwatchUrl, {
                wid: '18',
                hei: '18',
                fit: 'crop',
                sm: 'c'
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
              className: _visuallyHiddenModule.default.visuallyHidden,
              children: ["This colour is", ' ', swatch.isAvailable ? 'available' : 'unavailable']
            })]
          })
        }, swatch.skuId);
      }), showNotDisplayedTotal && notDisplayedTotal > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
        className: _swatchesModule.default.notDisplayedTotal,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
          className: (0, _classnames2.default)(_swatchesModule.default.moreColours, _swatchesModule.default['moreColours--remainingTotal']),
          href: baseUrl || (0, _getProductUrl.default)(title, id),
          onClick: handleMoreSwatchesClick,
          children: "+ ".concat(notDisplayedTotal)
        })
      })]
    }), showMoreAvailable && /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
      className: _swatchesModule.default.moreColours,
      href: baseUrl || (0, _getProductUrl.default)(title, id),
      onClick: handleMoreSwatchesClick,
      children: "+ More colours available"
    })]
  });
};
var _default = exports.default = Swatches;